export default {"src":"/_next/static/media/2.89ba6542.svg","height":170,"width":305,"blurWidth":0,"blurHeight":0};